export const mobileUiPrompt = `
A MOBIUI containing style
`;
export const thumbnailsPrompt = `Thumbnail in the style of TOK`;

export const instulatorGeneratorPrompt = `
You are an AI tool designed to generate vector 3D illustrations with a consistent theme. The theme includes modern, stylized characters in various scenarios, such as groups of diverse people or children playing. All illustrations should have a clean, minimalistic look with smooth edges and vibrant colors. The background should be transparent to allow direct use in Figma.

When a user requests an illustration, generate the image to match the following criteria:
1. Characters should have distinct, yet simple features with a friendly and approachable appearance.
2. Use a limited color palette that complements the overall aesthetic.
3. The setting should be relevant to the scenario requested by the user (e.g., playground for children, urban environment for adults).
4. Ensure all elements in the image are cohesive and align with the theme described. The background should always be transparent.

Examples of scenarios you can generate:
- Groups of diverse people in casual or work settings.
- Children playing in a playground or engaging in various activities.
- Individuals interacting with pets, such as a person playing with a dog.

Generate images based on the user guide.
`;

export const textToClaymationprompt = `Generate a highly detailed, vibrant claymation-style image based on the user's description. Ensure the image captures the essence of the scene with bright, sunny colors and intricate clay miniatures. Include specific elements mentioned in the description, such as characters, objects, and backgrounds, to bring the scene to life. For example, create a top view of a man with thread tied on his toes as he weaves a beautiful tassel, set against rolling green hills representing the vineyards of Paso Robles wine country. Use the appropriate aspect ratio specified by the user, such as 16:9 for landscape or 2:1 for wider scenes. Emphasize community respect, local lifestyle, and scenic beauty in relevant contexts like National Police Week in San Luis Obispo, CA`;

export const gtaprompt = `
GTA V Poster Style
Prompt Template: "a picture in the style of a GTA 5 poster game, GTA V, 16k, UHD, HDR, solo human, in the style of a gta 5 poster game, GTA V, Grand Theft Auto 5 poster, 16k, UHD, HDR, solo huma GTA 6 Style with Animals and Dynamic Background:.`;

export const PatternGenerator = `Generate a seamless, repeating pattern based on the user's description. Ensure that the design is consistent throughout, maintaining uniform motifs, shapes, lines, and textures. Use a harmonious color palette that complements the theme specified by the user. Focus on accurately representing the key elements of the user's prompt to capture the desired themes and characteristics. Avoid introducing any elements that are inconsistent with the user's description or disrupt the harmony of the pattern. The final design should be cohesive, harmonious, and true to the user's vision.`;

export const TattooGenerator = `Generate a unique and intricate tattoo design based on the user's description and preferences. The design should be visually appealing, detailed, and tailored to the user's style, theme, and placement preferences. Consider the following elements when creating the tattoo design:`;

export const VectorImage = `An hand drawn picture Generate a high-quality vector image based on the user's description also image background shoud be white and only Generate a blackline vector image and use shoud painting styles`;

export const aiIconMakerPrompt: { [key: string]: string } = {
  "3D": "3d render, unreal engine, realistic",
  "Pop Art":
    "pop art, digital illustation, vibrant colors, artstation, highly detailed",
  Doodle: "doodle artwork, cartoon, 2d vector, francis Picabia",
  Grunge: "grunge art, digital illustration, conrad Roset, highly detailed",
  Sticker: "sticker art, 2d vector, Johfra Bosschart, highly detailed",
  Realistic:
    "realistic art, digital illustration, highly detailed, Vincent Di Fate",
  Mosaic: "mosaic art, highly detailed, Edward Hopper",
  Origami:
    "japanese origami art, digital artwork, vector, Yuumei, highly detailed, artstation",
  "Chalkboard Art":
    "chalk art, digital illustration, Alexander Milne Calder, highly detailed",
  Metallic: "metallic, 3D render",
  Polygon:
    "vector art, symmetrical, digital painting, low poly, artstation, centered",
  Pixelated:
    "densely packed pixelated, symmetrical, minimalistic icon, centered, 2d vector art, artstation",
  Clay: "cute, 3D clay render, artstation",
  Gradient:
    "2d vector art, gradient, centered, artstation, digital illustration",
  Flat: "flat icon design, 2d vector art, minimal colors, sharp edges, artstation",
  Illustrated:
    "digital illustration, detailed, trending in artstation, fantasy vivid colors",
  Minimalistic: " minimalistic, artstation, vector art",
  "Hand-Drawn": "human hand-drawn, artstation",
  "Water Color":
    "watercolor, Jack Gaughan, Larry Elmore, Jack Davis, artstation",
  Isometric: "3d rendered, isometric, unreal engine, highly detailed",
  Neon: "neon lights, glowing edges, vibrant colors, dark background, artstation, digital illustration",
  Cartoonish:
    "cartoon style, playful, exaggerated features, bright colors, 2d vector, artstation",
};

export const aiAvatarPrompt: {
  [key: string]: { prompt: string; negativeprompt: string; imageSrc: string };
} = {
  CorporateProfessional: {
    prompt:
      "A professional headshot of a person dressed in formal business attire, such as a tailored suit or blazer, with a soft-focus office background. The lighting is even, highlighting the person's confident and approachable demeanor, suitable for LinkedIn profiles or corporate bios.",
    negativeprompt:
      "old, wrinkles, mole, blemish, scar, sad, severe, 3d, cg, nude, NSFW",
    imageSrc:
      "https://res.cloudinary.com/dcyrpk68d/image/upload/v1732021403/7b4a13fe-db24-4aed-96ce-2ea9b2c414f6.png",
  },

  MinimalistStudio: {
    prompt:
      "A sleek, minimalist portrait of a person in neutral-toned clothing, standing in front of a clean, solid-colored background. The lighting is soft and diffused, emphasizing simplicity and elegance, ideal for a modern and stylish aesthetic.",
    negativeprompt:
      "old, wrinkles, mole, blemish, scar, sad, severe, 3d, cg, nude, NSFW",
    imageSrc:
      "https://res.cloudinary.com/dcyrpk68d/image/upload/v1732022195/260aa6b9-3a86-4941-bf65-6f44c50fd138.png",
  },
  "Retro 80s Aesthetic": {
    prompt:
      "A vibrant portrait of a person dressed in bold 80s-inspired fashion with neon accents, standing in front of a retro-themed backdrop with glowing gridlines and vibrant colors. The image captures the energy of the era with dramatic lighting and high contrast",
    negativeprompt:
      "old, wrinkles, mole, blemish, scar, sad, severe, 3d, cg, nude, NSFW",
    imageSrc:
      "https://res.cloudinary.com/dcyrpk68d/image/upload/v1732022482/4164a2a4-0ceb-4c32-a859-e751a1e0bc25.png",
  },

  "Futuristic Cyberpunk": {
    prompt:
      "A cyberpunk-themed portrait of a person wearing futuristic attire with neon elements, standing in a glowing urban nightscape filled with holographic signs. The atmosphere is dark yet colorful, with reflective surfaces and neon lighting creating a sci-fi aesthetic.",
    negativeprompt:
      "old, wrinkles, mole, blemish, scar, sad, severe, 3d, cg, nude, NSFW, Avoid extreme or exaggerated contrasts that make the avatar look disjointed or unnatural. Exclude overly dramatic or unrealistic elements that disrupt the balance between the two seasonal themes.",
    imageSrc:
      "https://res.cloudinary.com/dcyrpk68d/image/upload/v1732022690/9126f09c-b07b-4b66-abe6-3068cbdb7542.png",
  },

  "Artistic Oil Painting": {
    prompt:
      "A classic oil painting-style portrait of a person wearing timeless clothing, captured in soft, textured brushstrokes. The background features muted tones with subtle artistic embellishments, resembling a museum-worthy Renaissance portrait.",
    negativeprompt:
      "old, wrinkles, mole, blemish, scar, sad, severe, 3d, cg, nude, NSFW, Avoid cartoonish or exaggerated features that detract from realism. Exclude backgrounds that are overly abstract or simplistic, which might break the immersion of the photorealistic style.",
    imageSrc:
      "https://res.cloudinary.com/dcyrpk68d/image/upload/v1732023098/371d90af-6772-4894-a4a0-4c218444f91e.png",
  },

  "Fantasy Royal": {
    prompt:
      "A regal portrait of a person dressed in elaborate, fantasy-inspired royal attire with intricate embroidery and accessories. The background is a grand, medieval-style castle interior with soft, glowing light and dramatic shadows.",
    negativeprompt:
      "old, wrinkles, mole, blemish, scar, sad, severe, 3d, cg, nude, NSFW, Avoid flat or simple textures that don't utilize the full potential of Octane rendering. Exclude plain or unrealistic backgrounds that don't complement the high-quality, detailed style.",
    imageSrc:
      "https://res.cloudinary.com/dcyrpk68d/image/upload/v1732023299/7cca9098-c60a-4a48-805a-9a9e070a15b4.png",
  },
  "Anime-Inspired": {
    prompt:
      "An anime-style illustration of a person with vibrant hair and expressive features, wearing trendy or fantasy-inspired clothing. The background is a colorful, hand-drawn landscape, with bright tones and dynamic composition to emphasize the playful anime aesthetic",
    negativeprompt:
      "old, wrinkles, mole, blemish, scar, sad, severe, 3d, cg, nude, NSFW, Avoid overly generic or clichéd mountain motifs that lack creativity or originality. Exclude elements that are unrelated to the mountain theme, such as beach accessories or urban clothing.",
    imageSrc:
      "https://res.cloudinary.com/dcyrpk68d/image/upload/v1732023468/07968020-85c2-4241-9076-31ce315052ea.png",
  },
  "Modern Streetwear": {
    prompt:
      "A stylish portrait of a person wearing trendy streetwear with bold patterns, oversized jackets, and sneakers, standing in an urban environment with graffiti-covered walls or a bustling cityscape. The image captures youthful energy and modern fashion.",
    negativeprompt:
      "old, wrinkles, mole, blemish, scar, sad, severe, 3d, cg, nude, NSFW",
    imageSrc:
      "https://res.cloudinary.com/dcyrpk68d/image/upload/v1732023637/4d53c87f-ab57-433e-84bf-7727b108833c.png",
  },
  "Vintage Hollywood Glamour": {
    prompt:
      "A glamorous black-and-white portrait of a person dressed in elegant vintage attire, such as a sleek gown or tuxedo, with dramatic lighting reminiscent of classic Hollywood photography. The background features a subtle stage curtain or studio backdrop.",
    negativeprompt:
      "old, wrinkles, mole, blemish, scar, sad, severe, 3d, cg, nude, NSFW",
    imageSrc:
      "https://res.cloudinary.com/dcyrpk68d/image/upload/v1732023802/71052bba-da5b-4e6f-8343-6c88b7eee8f4.png",
  },
  "Ethereal Fantasy": {
    prompt:
      "A magical portrait of a person dressed in flowing, mystical attire, surrounded by glowing orbs, mist, and ethereal light. The background is a dreamy forest or fantastical landscape filled with vibrant, otherworldly colors.",
    negativeprompt:
      "old, wrinkles, mole, blemish, scar, sad, severe, 3d, cg, nude, NSFW",
    imageSrc:
      "https://res.cloudinary.com/dcyrpk68d/image/upload/v1732023915/51109937-d43c-4dbb-8ff3-cdd0bdbc7d53.png",
  },

  "Gothic Noir": {
    prompt:
      "A moody, gothic portrait of a person dressed in dark, dramatic clothing with lace, leather, or velvet accents. The background features a dimly lit, gothic-style cathedral or cemetery with soft, eerie lighting for a mysterious vibe.",
    negativeprompt:
      "old, wrinkles, mole, blemish, scar, sad, severe, 3d, cg, nude, NSFW",
    imageSrc:
      "https://res.cloudinary.com/dcyrpk68d/image/upload/v1732024013/d16b05a9-1c6a-46c8-95fa-581a082429fb.png",
  },

  "Space Explorer": {
    prompt:
      "A futuristic portrait of a person in a sleek astronaut suit with glowing accents, standing in front of a cosmic backdrop featuring stars, nebulae, and planets. The lighting highlights the person's adventurous and sci-fi-inspired look.",
    negativeprompt:
      "old, wrinkles, mole, blemish, scar, sad, severe, 3d, cg, nude, NSFW",
    imageSrc:
      "https://res.cloudinary.com/dcyrpk68d/image/upload/v1732024177/7df3e2f1-d269-4fe3-95d8-c6a14426810d.png",
  },
  "Festival Bohemian": {
    prompt:
      "A vibrant portrait of a person dressed in colorful, bohemian-style clothing with accessories like floral headbands and layered jewelry. The background features a lively outdoor festival with tents, string lights, and colorful flags, capturing a free-spirited vibe",
    negativeprompt:
      "old, wrinkles, mole, blemish, scar, sad, severe, 3d, cg, nude, NSFW",
    imageSrc:
      "https://res.cloudinary.com/dcyrpk68d/image/upload/v1732024333/ab4a9592-16b2-40a6-b4a6-912f3c77c66b.png",
  },
  "Ancient Mythological Deity": {
    prompt:
      "A vibrant portrait of a person dressed in colorful, bohemian-style clothing with accessories like floral headbands and layered jewelry. The background features a lively outdoor festival with tents, string lights, and colorful flags, capturing a free-spirited vibe",
    negativeprompt:
      "old, wrinkles, mole, blemish, scar, sad, severe, 3d, cg, nude, NSFW",
    imageSrc:
      "https://res.cloudinary.com/dcyrpk68d/image/upload/v1732024839/914cc7f9-5d5b-45c7-bdd6-35b555f77837.png",
  },
  "Neon Glow Portrait": {
    prompt:
      "A vibrant portrait of a person illuminated by neon lights, with glowing accents on the face and clothing. The background features a moody urban nightscape with neon signs and reflections. The style emphasizes a futuristic, energetic vibe, with bold colors like pink, blue, and purple dominating the composition",
    negativeprompt:
      "old, wrinkles, mole, blemish, scar, sad, severe, 3d, cg, nude, NSFW",
    imageSrc:
      "https://res.cloudinary.com/dcyrpk68d/image/upload/v1732025087/0de648ab-1992-4b43-8c0b-d94c0539c7bb.png",
  },
  "Tropical Beach Swimsuit": {
    prompt:
      "A stylish portrait of a person wearing a modern swimsuit, standing on a tropical beach with golden sand and crystal-clear waters. The background features swaying palm trees and a vibrant blue sky with soft clouds. The lighting is warm and natural, highlighting the relaxed and summery vibe",
    negativeprompt:
      "old, wrinkles, mole, blemish, scar, sad, severe, 3d, cg, nude, NSFW",
    imageSrc:
      "https://res.cloudinary.com/dcyrpk68d/image/upload/v1732025243/c816741f-32a7-4ef2-b48d-7d2bda862983.png",
  },
  "Dreamy Fantasy Princess/Prince": {
    prompt:
      "A whimsical portrait of a person dressed in flowing royal attire adorned with jewels and embroidery. The background features a magical castle with glowing lights and soft pastel hues, creating a fairy-tale-inspired look with an ethereal glow.",
    negativeprompt:
      "old, wrinkles, mole, blemish, scar, sad, severe, 3d, cg, nude, NSFW",
    imageSrc:
      "https://res.cloudinary.com/dcyrpk68d/image/upload/v1732025478/64188382-4e8a-4f47-9e95-c6e681248554.png",
  },
  "Noir Detective": {
    prompt:
      "A cinematic black-and-white portrait of a person dressed in vintage detective clothing, such as a trench coat and fedora. The background features a moody, rain-soaked city street illuminated by dim streetlights. The composition captures a mysterious and classic film noir aesthetic.",
    negativeprompt:
      "old, wrinkles, mole, blemish, scar, sad, severe, 3d, cg, nude, NSFW",
    imageSrc:
      "https://res.cloudinary.com/dcyrpk68d/image/upload/v1732025663/190ef5be-f091-4451-b6bb-c4995630ee75.png",
  },
  Steampunk: {
    prompt:
      "A steampunk-style portrait of a person dressed in Victorian-era attire, complete with leather goggles, brass buttons, and intricate mechanical gears. The background features a dimly lit, industrial workshop with steam-powered machinery and gears, capturing a retro-futuristic vibe.",
    negativeprompt:
      "old, wrinkles, mole, blemish, scar, sad, severe, 3d, cg, nude, NSFW",
    imageSrc:
      "https://res.cloudinary.com/dcyrpk68d/image/upload/v1732025965/cbb89204-57ba-476a-9a5b-c4f2c490285e.png",
  },

  // Add the rest of the entries in the same format
};

// AI photoshoot
export const AIPhotoShootStyles = {
  styles: [
    {
      name: "abstract",
      prompt:
        "Abstract photography captures imaginative non-representational subjects creatively using visual elements like color and texture. For strong abstract images in Stable Diffusion weight the tag at (abstract:1.4).",
    },
    {
      name: "analogue",
      prompt:
        "Analogue photography uses film and traditional developing processes to achieve a classic vintage look with grain, fading discoloration, light leaks, and textured imperfections absent in slick digital images. Useful for a generic vintage look.",
    },
    {
      name: "beauty",
      prompt:
        "Beauty photography involves capturing elegant, stylized portraits of models to highlight and celebrate cosmetics glamor, and aesthetically pleasing subjects in a romanticized way. Combine with studio themed lighting prompts.",
    },
    {
      name: "candid",
      prompt:
        "Candid photography involves taking spontaneous, unposed shots of people behaving naturally in public settings without their knowledge to capture authentic moments. Add actions to your prompt and a public setting to make this work well.",
    },
    {
      name: "documentary photography",
      prompt:
        "Documentary photography captures real world subjects environments, events, and people in their authentic contexts to provide visual insight into culturally significant topics. This can create very realistic skin & is effective in black and white.",
    },
    {
      name: "glamour photography",
      prompt:
        "Glamour photography involves stylized, idealized portraits of models showcasing cosmetics, seductive poses, and sensual allure to convey an aspirational image of beauty. You may want to use NSFW in your negative prompts or this will create nudes.",
    },
    {
      name: "high fashion photography",
      prompt:
        "High fashion photography promotes cutting-edge designer clothing and accessories using inventive, avant garde artistic approaches, striking poses, and models to showcase an aspirational elegance. Also use catwalk as a setting tag.",
    },
    {
      name: "instant photo",
      prompt:
        "Instant photos have a retro, vintage Polaroid look with faded colors, uneven exposures, imperfections, and blotchy shadows created immediately when taken without development. Weight the tag at (instant photo:1.4). Add soft focus & a film type tag.",
    },
    {
      name: "large format",
      prompt:
        "Large format photography uses cameras with film sizes of 4x5 inches or larger to achieve incredibly high resolution, sharpness fine grain, and detailed photos suitable for large prints. this tag gives sharp images but with an organic film grain.",
    },
    {
      name: "lifestyle photography",
      prompt:
        "Lifestyle photography involves capturing candid, documentary-style shots of people, in everyday home or domestic situations to convey personality and meaningful moments. Use with action and setting tags to create stock photo style images.",
    },
    {
      name: "modernist",
      prompt:
        "Modernist photography is characterized by simple, geometric compositions, minimalism, & emphasis on shape. In Stable Diffusion, however, it creates a 1960's aesthetic more in line with Modernist architecture.",
    },
    {
      name: "paparazzi",
      prompt:
        "Paparazzi photography involves candid shots of celebrities going about daily life without permission, often dangerously or unethically, to capture scandalous, sensationalist, or intimate images.",
    },
    {
      name: "pictorialist style",
      prompt:
        "Pictorialist photography from the 1800's mimics impressionist paintings using soft focus, diffused lighting, to make dreamlike romanticized images. Add soft focus, dreamy haze & black and white tags to enhance. Use a weight of (pictorialist:1.5).",
    },
    {
      name: "polaroid",
      prompt:
        "Polaroid photography uses instant film that develops prints immediately, producing retro-style images with faded color uneven exposures, shadows, and imperfections absent in modern digital photos. Unlike instant this tag has softer images.",
    },
    {
      name: "pinhole photography",
      prompt:
        "Pinhole photography uses a camera without a lens that has a tiny pinhole aperture, creating soft focus dreamlike images with nearly infinite depth of field but requiring long exposures.",
    },
    {
      name: "street fashion photography",
      prompt:
        "Street fashion photography captures candid shots of stylish real people in urban settings wearing creative street style outfits and designs outside of studios or runways.",
    },
    {
      name: "surrealist",
      prompt:
        "Surrealist photography creates fantastical, dreamlike images using imaginative composites, collages, darkroom manipulations, and unusual juxtapositions to convey subconscious realities. Needs a weight of (surrealist photo:1.5).",
    },
    {
      name: "tintype",
      prompt:
        "Tintype photography involves capturing direct positive images onto lacquered iron plates, producing antique looking photos with high contrast, dark muted tones, and ghostly faded faces. High weights this will always make subjects look old fashioned.",
    },
  ],
  framing: [
    {
      name: "close up on face",
      prompt:
        'Specifying "close up on face" in a portrait prompt frames tight on facial features to reveal emotion, identity, and fine details. Use it to highlight expressions and direct focus exclusively on the subject.',
    },
    {
      name: "full body",
      prompt:
        'Specifying "full body" frames the entire subject to showcase action, attire, and context. Use it for dynamic poses, to emphasize a key outfit or to establish a scene.',
    },
    {
      name: "head shot",
      prompt:
        'Head shots tightly frame the face to spotlight identity, facial features, and expressive emotions. Use "head shot" to focus attention on nuanced details of the face and head. This framing includes more of the hair and shoulders.',
    },
    {
      name: "upper body",
      prompt:
        "Upper body framing shows the subject from chest or waist up focusing on pose, expression, clothing, and hand gestures while still providing some environmental context.",
    },
  ],
  lighting: [
    {
      name: "bounced lighting",
      prompt:
        'Bounced lighting refers to soft, diffuse illumination created by reflecting light off surrounding surfaces like walls and ceilings rather than directly lighting the subject from the source. This can be prompted by specifying "soft bounced lighting".',
    },
    {
      name: "candlelight",
      prompt:
        "Candlelight produces a warm, intimate, flickering glow with subtle dancing shadows and highlights that can be prompted by specifying a scene lit solely by candles. This can be combined with another lighting style called chiaroscuro.",
    },
    {
      name: "chiaroscuro",
      prompt:
        "Chiaroscuro lighting refers to high contrast illumination with strong shadows juxtaposed against bright highlights, which creates a dramatic, textured look. In Stable Diffusion this can create a photorealistic Renaissance painting style.",
    },
    {
      name: "cinematic lighting",
      prompt:
        'Cinematic lighting uses dramatic high-contrast keys, backlights and rims to create moody Hollywood style portrait lighting effects that can be prompted in Stable Diffusion by specifying "cinematic lighting" with strong side key lights or rim lighting.',
    },
    {
      name: "soft diffused lighting",
      prompt:
        'Diffused lighting is soft, low contrast illumination from a large diffusing light source that creates gentle shadows and can be prompted in Stable Diffusion by specifying a scene uses "soft diffused lighting" to create a smooth, even lighting effect.',
    },
    {
      name: "edge lighting",
      prompt:
        'Edge lighting is side lighting placed behind a subject to produce a bright outlined "rim" effect around their silhouette which can be prompted in Stable Diffusion by specifying "dramatic edge lighting" to make the subject vividly stand out.',
    },
    {
      name: "fill lighting",
      prompt:
        'Fill lighting provides secondary illumination from the opposite side of the key light to soften shadows and balance out contrast which can be prompted in Stable Diffusion by specifying "soft fill lighting" to gently brighten shaded areas of a subject.',
    },
    {
      name: "flash photography",
      prompt:
        'This utilizes a burst of bright, instant light that can create a sharp yet stylistic look, which can be prompted in Stable Diffusion with "direct flash photography" or "harsh flash lighting". Too high a weight will add the flash symbol to everything! So be warned.',
    },
    {
      name: "god rays",
      prompt:
        'God rays lighting creates dramatic beams of light streaming through particulate in the air which can be prompted by specifying "radiant god rays" or "light beams streaming through haze" to generate an atmospheric, mystical lighting effect.',
    },
    {
      name: "golden hour",
      prompt:
        'Golden hour lighting refers to the warm, reddish hue and softened shadows created by the low angle of the sun at sunrise or sunset, which can be prompted by specifying "warm golden hour lighting" to generate a romantic, magical ambience.',
    },
    {
      name: "hard light",
      prompt:
        "Hard lighting refers to harsh, undiffused illumination that creates strong shadows and high contrast, which can be prompted by specifying a scene uses (hard lighting:1.4) to portray bold shapes and textures and a dramatic mood.",
    },
    {
      name: "high key lighting",
      prompt:
        'High key studio lighting employs bright, even illumination against a white backdrop to create a clean, modern look with some contrast but minimal shadows in fashion and editorial photography. Prompted by specifying "high key brightly lit"',
    },
    {
      name: "low key lighting",
      prompt:
        'Low key lighting uses dramatic, moody illumination with shadows and dark, muted tones, typically prompted by specifying a "low key lighting" scene with minimal fill lighting to create higher contrast intrigue and a mysterious mood.',
    },
    {
      name: "natural lighting",
      prompt:
        'Natural lighting utilizes the sun or other ambient light sources to gently illuminate a scene and can be prompted by specifying "soft natural lighting" to create a realistic, organic mood and avoid the artificial look of studio lighting in one sentence.',
    },
    {
      name: "neon lighting",
      prompt:
        'Neon lighting employs the vibrant, saturated colors of neon tube lights which can create a lively, futuristic, or stylized look typically prompted by specifying a scene uses "bright neon lighting" to generate a colorful, artificial lighting effect.',
    },
    {
      name: "overcast lighting",
      prompt:
        'Overcast lighting refers to the soft, even, low contrast illumination on cloudy days, which can be prompted by specifying "overcast flat lighting" to simulate the muted shadows and tone of an overcast sky.',
    },
    {
      name: "rim lighting",
      prompt:
        'Rim lighting is a strong back light placed behind a subject to create an outlined "rim" or glow effect around their silhouette typically prompted by specifying "dramatic rim lighting" to make the subject stand out vividly from the background',
    },
    {
      name: "shadow play",
      prompt:
        'Shadow play lighting creates dramatic results by strategically placing shadows and shafts of light, typically prompted by specifying "creative shadow play" to generate high contrast and visual intrigue in a scene.',
    },
    {
      name: "silhouette lighting",
      prompt:
        'Creates a silhouette effect by placing the subject or object in front of a bright backlight, usually prompted by specifying "silhouetted against the bright sky/window/light" to generate a bold darkened subject profiled against the background.',
    },
    {
      name: "soft lighting",
      prompt:
        'Soft lighting minimizes shadows by using a large, diffused light source and can be prompted in Stable Diffusion by specifying "soft lighting" to create a gentle, smooth illumination that reduces texture and contrast',
    },
  ],
  cameraAngle: [
    {
      name: "dutch angle",
      prompt:
        'A Dutch angle refers to tilting the camera diagonally to create a skewed perspective, typically prompted in Stable Diffusion by specifying "shot from a Dutch angle" to make the composition appear more dynamic or convey unease. Use with high weight.',
    },
    {
      name: "from above/high angle",
      prompt:
        'Specifying a "high angle" or shooting "from above" refers to positioning the camera above the subject pointing down, which can frame the subject from an elevated viewpoint to emphasize smallness, vulnerability or isolation within the scene.',
    },
    {
      name: "from below/low angle",
      prompt:
        'Specifying a "low angle" or shooting "from below" refers to positioning the camera below the subject pointing up, which can prompt SD to frame the subject from a low viewpoint to exaggerate power, height and dominance within the scene.',
    },
    {
      name: "eye level",
      prompt:
        'Specifying an "eye level" camera angle refers to positioning the camera at the same height as the subject\'s eyes, typically prompted in Stable Diffusion to create a direct perspective that conveys neutrality and intimacy with the subject.',
    },
  ],
  cameraProperties: [
    {
      name: "Aaton LTR",
      prompt:
        'The Aaton LTR 54 was a highly adaptable S16 cinema film camera which can be prompted in Stable Diffusion by specifying "shot on Aaton LTR" to emulate its natural perspective, subtle vignette look, and the texture of film.',
    },
    {
      name: "ARRI ALEXA 65",
      prompt:
        'A high-end 65mm digital cinema camera known for its extremely high resolution and dynamic range, which can be prompted by specifying "shot on ALEXA 65" for detailed, crisp images with smooth tonality similar to its large format look.',
    },
    {
      name: "Bolex H16",
      prompt:
        'The Bolex H16 was a versatile, hand-cranked 16mm film camera which can be prompted in Stable Diffusion by specifying "shot on Bolex H16" to emulate its vintage 16mm look, natural vignette and handheld footage aesthetic.',
    },
    {
      name: "RED Digital Cinema Camera",
      prompt:
        'The RED Digital Cinema Camera produces high-resolution digital footage with customizable color science, which can be simulated by specifying "shot on RED camera" desired RED image attributes include wide dynamic range and crisp details.',
    },
    {
      name: "Canon EOS 5D",
      prompt:
        'The Canon EOS 5D pioneered large sensor digital photography with cinema-quality shallow depth of field, which can be prompted with "shot on Canon EOS 5D" & referencing desired attributes like smooth background bokeh.',
    },
    {
      name: "Fujifilm X-T4",
      prompt:
        "The Fujifilm X-T4 mirrorless camera produces images with Fujifilm's acclaimed color science and film simulation modes which can be simulated by prompting desired attributes like saturated colors, high contrast tones, and natural grain.",
    },
    {
      name: "GoPro Hero",
      prompt:
        'The GoPro Hero action camera captures ultra wide-angle point-of-view footage with a bold fisheye look that can be creatively prompted using "(shot on GoPro Hero:1.4)".',
    },
    {
      name: "Hasselblad X1D II",
      prompt:
        'A medium format camera that produces extremely high res images with tons of detail and Hasselblad\'s iconic tonality, which can be simulated by prompting "shot on Hasselblad X1D II" with tags like fine texture, smooth color gradations.',
    },
    {
      name: "Lumix GH5",
      prompt:
        'The Panasonic Lumix GH5 is a Micro Four Thirds mirrorless camera known for its versatility in high bitrate 4K video, which can be creatively prompted with "shot on Lumix GH5" and tags like, cinematic bokeh, dynamic range, and vibrant colors.',
    },
    {
      name: "Pentax 645Z",
      prompt:
        'The Pentax 645Z medium format DSLR produces ultra high resolution images with tons of detail and incredible dynamic range, perfect for prompting "shot on Pentax 645Z" with rich textures, and smooth wide tonality.',
    },
    {
      name: "Sony A7III",
      prompt:
        'The Sony A7III full frame mirrorless camera offers immense flexibility with its advanced autofocus, prompt using "shot on Sony A7III".',
    },
    {
      name: "Leica T",
      prompt:
        'The Leica T mirrorless APS-C system delivers Leica\'s renowned image quality in a sharp modern form factor. Prompt with "shot on Leica T". Add tags like smooth skin tone, Leica colors, shallow depth of field and vignetting.',
    },
    {
      name: "Diana F+",
      prompt:
        "This plastic toy camera has a cult following for its dreamy soft focus and vignetted images perfect for images with a hazy retro film aesthetic. Use with a weight of 1.6, film grain, dreamy haze blur and light leak tags. High-Res fix will reduce the effect.",
    },
    {
      name: "Hasselblad 500CM",
      prompt:
        "The Hasselblad 500CM medium format film camera produces images with incredible detail and tonality, perfect for prompting ultra-high resolution shots with subtle smooth transitions between colors and tones.",
    },
    {
      name: "HOLGA 120n",
      prompt:
        "The Holga 120N toy film camera has a cult following for its vignetted, blurry, low-fi dreamlike images with light leaks perfect for prompting imaginative impressions with an unpredictable retro aesthetic.",
    },
    {
      name: "Kodak Brownie",
      prompt:
        "The Kodak Brownie box camera has an iconic vintage look with square medium format images, dark vignettes, soft focus and muted color tones perfect for prompting a nostalgic, retro stylistic perspective.",
    },
    {
      name: "Kodak Funsaver",
      prompt:
        "This plastic toy camera has a cult following for its dreamy soft focus and vignetted images perfect for images with a hazy retro film aesthetic. Use with a weight of 1.6, film grain, dreamy haze blur and light leak tags. High-Res fix will reduce the effect.",
    },
    {
      name: "Leica M3",
      prompt:
        "The Leica M3 rangefinder camera is known for its discreet operation, quiet shutter release, and exceptional image quality that enables prompting classic Leica tonality, microcontrast, and perspective from its superb prime lenses.",
    },
    {
      name: "Rolleiflex",
      prompt:
        "The Rolleiflex twin lens reflex medium format camera produces images with incredible detail and tonality perfect for prompting ultra-sharp photos with a distinctively intimate square perspective.",
    },
    {
      name: "Polaroid SX-70",
      prompt:
        "The Polaroid SX-70 instant camera has a signature square format with flat, muted colors, distinctive light streaks, and immediate tangible prints perfect for prompting nostalgic analog images with a faded retro aesthetic.",
    },
  ],
  filmType: [
    {
      name: "Agfa Vista",
      prompt:
        "Agfa Vista was an inexpensive color print film known for its wild oversaturated colors, making it perfect for prompting images with an intensely vibrant, saturated aesthetic.",
    },
    {
      name: "Cinestill 800T",
      prompt:
        "Cinestill 800T is a tungsten-balanced 35mm motion picture film adapted for still photography, producing a signature low-fi crossover look with halation light leaks and rich cinematic colors that can be prompted by specifying its classic film attributes.",
    },
    {
      name: "Ektar 100",
      prompt:
        "Kodak Ektar 100 is a fine grain 35mm color negative film prized for its incredibly saturated colors and clean sharpness, ideal for prompting images with vivid, true-to-life color rendition and detail.",
    },
    {
      name: "film grain",
      prompt:
        'Film grain refers to the visible texture and particles inherent in analog photographic film, which can be prompted by specifying desired qualities like "prominent grain", "muted low grain", or "fine grain" to achieve different textured retro film looks.',
    },
    {
      name: "Ilford HP5 Plus",
      prompt:
        "Ilford HP5 Plus is an ISO 400 black and white film prized for its versatility, and characteristic medium grain, which makes it great for prompting flexible black and white images with a stylized classic film grain look. Weight needs to be over 1.6.",
    },
    {
      name: "Kodak Vision3",
      prompt:
        "Kodak Vision3 is a professional 35mm motion picture camera film stock designed to deliver rich, vibrant color and fine grain ideal for prompting cinematic images and footage with robust color rendition and smooth textures.",
    },
    {
      name: "Kodak Vision3 IMAX",
      prompt:
        "Kodak Vision3 IMAX is a large format 65mm color negative film specifically engineered for IMAX cameras to produce unparalleled levels of fine detail perfect for prompting crisp intricate, high-resolution images with tons of visual information.",
    },
    {
      name: "Lomochrome color film",
      prompt:
        "Lomography Chromatic film, or Lomachrome, is a 35mm ISO 800 color negative film known for its vivid and unpredictable color shifts. Use this prompt with the Holga 120n or Diana F+ camera tags to make it work.",
    },
    {
      name: "Porta 160",
      prompt:
        "Kodak Portra 160 is a 160 ISO color negative film celebrated for its saturated colors and flattering skin tones, ideal for portrait prompts requiring smooth tones and natural color rendition.",
    },
    {
      name: "Tri-X 400",
      prompt:
        "Kodak Tri-X 400 is a classic ISO 400 monochromatic film distinguished by its rich blacks, broad exposure latitude, and distinct medium-sized grain, use with high weight of 1.8",
    },
    {
      name: "Velvia 100",
      prompt:
        "Fujifilm Velvia 100 is a bright, vivid color reversal film known for its incredible saturation and fine grain, ideal for prompting brilliant landscape images with lush, dramatic colors and tons of detail.",
    },
    {
      name: "Fujicolor Pro",
      prompt:
        "Fujicolor Pro film is known for its natural, accurate, and well-balanced color reproduction perfect for prompting images with a realistic and subtle Fujifilm color palette.",
    },
  ],
  lens: [
    {
      name: "50mm",
      prompt:
        "A 50mm prime lens provides a natural field of view similar to human vision, useful for prompting realistic perspective in documentary or portrait photography styles",
    },
    {
      name: "8mm Fisheye Lens",
      prompt:
        "A fisheye lens captures a spherical 180-degree field of view with strong circular barrel distortion perfect for prompting an immersive hemispherical perspective.",
    },
    {
      name: "Voigtländer Nokton 50mm f1.1",
      prompt:
        "produces dreamy images with extremely shallow depth of field and buttery smooth bokeh",
    },
  ],
  filterEffects: [
    {
      name: "black and white",
      prompt:
        "Removing color saturation creates monochromatic images focused on light, shapes, texture and mood.",
    },
    {
      name: "color filter",
      prompt:
        "Change color to the color you want to adds a tint over the image to darken skies similar to using an actual colored glass filter on a film camera lens.",
    },
    {
      name: "bokeh",
      prompt:
        "Buttery smooth, aesthetically blurred out-of-focus backgrounds artistically isolate the main subject by minimizing distractions.",
    },
    {
      name: "desaturated",
      prompt: "",
    },
    {
      name: "grunge filter",
      prompt:
        "Removing color vibrancy and overlaying film grain, stains and defects creates a worn weathered, grungy texture.",
    },
    {
      name: "dreamy haze",
      prompt:
        "Ethereal, romantic imagery emerges through soft focus light haze, subtle distortions and a detached, floating perspective.",
    },
    {
      name: "glitch style",
      prompt:
        "Manipulating or corrupting digital imagery to intentionally introduce distortions, artifacts colors shifts, banding, and other digital aberrations",
    },
    {
      name: "hologram effect",
      prompt:
        "Creates a holographic lighting effect to clothing and backgrounds",
    },
    {
      name: "(infrared filter:1.4)",
      prompt:
        "Emulates the extreme color shifts of infrared photography dominated by pinkish hues from foliage and skies to uniquely reinterpret reality.",
    },
    {
      name: "lens flare",
      prompt:
        "Vivid polygonal lens flares stylize the scene by adding striking bursts of light as if beams were intersecting the camera optics.",
    },
    {
      name: "sepia tone",
      prompt:
        "Warm antique sepia pigment toning imbues a nostalgic vintage aesthetic. Use with a low weight to avoid your subject being historical.",
    },
    {
      name: "soft focus",
      prompt:
        "Intentionally diffusing sharpness through spherical aberration lends a romantic, dreamy impression.",
    },
    {
      name: "solarized",
      prompt:
        "Partially inverting the tonal range by blocking shadows creates a surreal duotone look.",
    },
    {
      name: "long exposure",
      prompt:
        "Blurring any motion conveys the passage of time and artistic intentionality through extended exposure techniques.",
    },
    {
      name: "ND filter",
      prompt:
        "Neutral density filters reduce incoming light levels, allowing slower shutter speeds to smoothly capture and etherealize motion.",
    },
    {
      name: "overexposed",
      prompt:
        "Increasing exposure washes out imagery with bright whites, pure hues, and solarized effects to focus on light and color.",
    },
    {
      name: "technicolor",
      prompt:
        "Mimicking the saturated look of old Technicolor film processes through vibrant, dramatic colors.",
    },
    {
      name: "underexposed",
      prompt:
        "Decreasing exposure mutes the image with dark shadows and somber tones for mysterious low key effects.",
    },
    {
      name: "vignette",
      prompt:
        "Framing the central subject by gradually darkening the outer corners and edges puts emphasis on the main focus.",
    },
  ],
  photographers: [
    {
      name: "Alberto Seveso",
      prompt: "Alberto Seveso",
    },
    {
      name: "Alex Timmermans",
      prompt: "Alex Timmermans",
    },
    {
      name: "Alfred Stieglitz",
      prompt: "Alfred Stieglitz",
    },
    {
      name: "Ando Fuchs",
      prompt: "Ando Fuchs",
    },
    {
      name: "Anne Brigman",
      prompt: "Anne Brigman",
    },
    {
      name: "August Sander",
      prompt: "August Sander",
    },
    {
      name: "Brandon Woelfel",
      prompt: "Brandon Woelfel",
    },
    {
      name: "Chris Friel",
      prompt: "Chris Friel",
    },
    {
      name: "David LaChapelle",
      prompt: "David LaChapelle",
    },
    {
      name: "Eugene Atget",
      prompt: "Eugene Atget",
    },
    {
      name: "Garry Winograd",
      prompt: "Garry Winograd",
    },
    {
      name: "George Hurrell",
      prompt: "George Hurrell",
    },
    {
      name: "Germaine Krull",
      prompt: "Germaine Krull",
    },
    {
      name: "Hans Bellmer",
      prompt: "Hans Bellmer",
    },
    {
      name: "Hayao Miyazaki",
      prompt: "Hayao Miyazaki",
    },
    {
      name: "James Bidgood",
      prompt: "James Bidgood",
    },
    {
      name: "Kim Keever",
      prompt: "Kim Keever",
    },
    {
      name: "Lee Friedlander",
      prompt: "Lee Friedlander",
    },
    {
      name: "Liam Wong",
      prompt: "Liam Wong",
    },
    {
      name: "Lotte Reiniger",
      prompt: "Lotte Reiniger",
    },
    {
      name: "Martin Schoeller",
      prompt: "Martin Schoeller",
    },
    {
      name: "Mickalene Thomas",
      prompt: "Mickalene Thomas",
    },
    {
      name: "Miko Lagerstedt",
      prompt: "Miko Lagerstedt",
    },
    {
      name: "Miles Aldridge",
      prompt: "Miles Aldridge",
    },
    {
      name: "Misha Gordin",
      prompt: "Misha Gordin",
    },
    {
      name: "Nan Goldin",
      prompt: "Nan Goldin",
    },
    {
      name: "Nathan Wirth",
      prompt: "Nathan Wirth",
    },
    {
      name: "Nick Knight",
      prompt: "Nick Knight",
    },
    {
      name: "Oleg Oprisco",
      prompt: "Oleg Oprisco",
    },
    {
      name: "Oskar Fischinger",
      prompt: "Oskar Fischinger",
    },
  ],
};
